<template>
  <div class="no_role">
    <div class="tit">提醒</div>
    <p>{{message?message:'暂未查询到任何角色，换个区服试试吧~'}}</p>
    <van-button round color="var(--theme)" class="know" @click="close">知道了</van-button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      message: this.selection.message
    }
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {
    close() {
        this.$emit('closeModal')
    }
  },
  watch: {},
}
</script>

<style lang="less" scoped>
.no_role {
    padding: 2.8rem 2.2rem;
    .tit {
        font-size: 1.6rem;
        font-weight: 700;
        color: #ef4d3d;
        text-align: center;
        margin-bottom: 2.2rem;
    }   
    p {
        font-size: 1.4rem;
        color: #555;
        margin-bottom: 4.6rem;
        text-align: center;
    }
    .know {
        padding: 0;
        height: 3.2rem;
        width: 100%;
        font-size: 1.6rem;
    }
}
</style>
